<template>
	<div class="menus-wrap">
		<head-info></head-info>
		<div class="relative-wrap">
			<el-descriptions :column="1" title="考生报考信息" border>
				<el-descriptions-item label="报名序号" :labelStyle="{ width: '150px' }">{{ serial_id }}</el-descriptions-item>
				<el-descriptions-item label="缴费状态" v-if="showPay && info.is_pay!==4">
					<template v-if="info.is_pay === 1">
						<span style="color: #F56C6C;">{{ is_pay }}</span>
					</template>
					<template v-else>
						<span style="color: #67C23A;">{{ is_pay }}</span>
					</template>
				</el-descriptions-item>
				<el-descriptions-item label="参考确认" v-if="!showPay && info.is_pay===4">
					<template v-if="info.is_pay === 1">
						<span style="color: #F56C6C;">{{ is_pay }}</span>
					</template>
					<template v-else>
						<span style="color: #67C23A;">{{ is_pay }}</span>
					</template>
				</el-descriptions-item>
				<el-descriptions-item label="审核状态">
					<template v-if="info.verify === 3">
						<span style="color: #67C23A;">{{ verify }}</span>
					</template>
					<template v-else>
						<span style="color: #F56C6C;"><pre>{{ verify }}</pre></span>
					</template>
				</el-descriptions-item>
				<el-descriptions-item v-if="info.category_name" label="岗位类别">{{ info.category_name || '-' }}</el-descriptions-item>
				<el-descriptions-item label="报考单位">{{ info.department || '-' }}</el-descriptions-item>
				<el-descriptions-item label="报考岗位">{{ info.position || '-' }}</el-descriptions-item>
				<el-descriptions-item v-if="info.classify" label="考试类别" :span="2">{{ info.classify }}</el-descriptions-item>
				<el-descriptions-item label="报考科目(元)">
					<template v-if="info.subject && info.subject.length">
						<p v-for="item in info.subject">{{ item.subject_name }}：{{ item.amount }}元</p>
					</template>
					<template v-else>
						-
					</template>
				</el-descriptions-item>
			</el-descriptions>
			<div style="position: relative;">
				<div class="photo"><img v-if="info.photo" :src="info.photo + '?_=' + new Date().getTime()" alt=""/></div>
				<el-descriptions :column="2" title="考生基本信息" border>
					<el-descriptions-item  :labelStyle="{ width: '300px' }"label="姓名">{{ info.name }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ width: '0', backgroundColor: '#fff', border: '1px solid transparent' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<el-descriptions-item label="性别">{{ info.gender && info.gender === 1 ? '男' : info.gender && info.gender === 2 ? '女' : '-' }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<el-descriptions-item label="身份证号">{{ info.card_id || '-' }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<el-descriptions-item label="出生年月">{{ info.date_birth || '-' }}</el-descriptions-item>
					<el-descriptions-item
						labelClassName="labelClassName"
						:labelStyle="{ backgroundColor: '#fff', border: '1px solid transparent', borderBottomColor: '#EBEEF5' }"
						:contentStyle="{ width: '150px', border: '1px solid transparent', borderBottomColor: '#EBEEF5', borderRightColor: '#EBEEF5' }"
					></el-descriptions-item>
					<template v-for="(item, index) in info.details ? info.details : []">
						<el-descriptions-item v-if="+item.type === 5" :label="item.name" :span="2" :labelStyle="{ width: '150px' }">
							<div class="grid-wrap">
								<el-image
									v-for="(val, index) in item.value"
									:key="index"
									style="width: 100px; height: 100px;background-color: #f5f7fa;line-height: 100px;"
									:src="val.url"
									:preview-src-list="item.value.map(v => v.url)"
								>
									<div slot="error" style="text-align: center;"><i style="font-size: 30px;" class="el-icon-picture-outline"></i></div>
								</el-image>
							</div>
						</el-descriptions-item>
						<el-descriptions-item :span="2" v-else-if="+item.type === 4" :label="item.name">{{ item.value?item.value.join('、'):'' }}</el-descriptions-item>
						<el-descriptions-item :span="2" v-else :label="item.name"><pre>{{ item.value }}</pre></el-descriptions-item>
					</template>
				</el-descriptions>
			</div>
		</div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import { mapState,mapGetters } from 'vuex';
import { reqGetUserInfo } from '@/api';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			info: {
				payment: {
					alipay_app_id: null,
					wechat_app_id: null,
					yeepay_app_id: null
				}
			}
		};
	},
	computed: {
		...mapState({
			serial_id: state => state.user.examinee.serial_id,
			payment: state => state.system.payment,
		}),
		...mapGetters('user',['GET_USER_INFO']),
		is_pay() {
			try {
				return this.info.is_pay === 1 ? '未缴费' : this.info.is_pay === 2 ? '已缴费' : this.info.is_pay === 3 ? '已减免' : this.info.is_pay === 4 ? '已确认' : this.info.is_pay === 5 ? '申请退费' : this.info.is_pay === 0 ? '已退费' : '-';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},
		verify() {
			try {
				return this.info.verify === 1 ? '未审核' : this.info.verify === 2 ? `未通过（原因：${this.info.verify_txt}）` : this.info.verify === 3 ? '已通过' : `等待审核（原因：${this.info.verify_txt}）`;
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},
		/*verify() {
			try {
				return this.info.retrial === 3 ? '已通过' : this.info.verify === 2 ? `未通过（原因：${this.info.verify_txt}）` : this.info.retrial === 2 ? `未通过（原因：${this.info.verify_retrial_txt}）` : this.info.verify === 4 ? `等待审核（原因：${this.info.verify_txt}）` : '未审核';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},*/
		// 显示缴费状态
		showPay() {
			return this.payment && (this.payment.alipay_app_id || this.payment.wechat_app_id || this.payment.yeepay_app_id);
		}
	},
	activated() {
		this.getInfo();
	},
	methods: {
		// 获取考生详情
		async getInfo() {
			this.info = this.GET_USER_INFO;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';

.relative-wrap {
	position: relative;
	margin: 15px auto 0;
	max-width: 1000px;

	.photo {
		width: 130px;
		height: 130px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		top: 113px;
		right: 96px;
		transform: translate(50%, -50%);

		img {
			max-width: 130px;
			max-height: 130px;
			object-fit: cover;
		}
	}
	pre {
		font-family: "Microsoft YaHei";
		white-space: pre-wrap;
		word-wrap: break-word;
		tab-size: 7;
		-moz-tab-size: 7;
		-o-tab-size: 7;

	}

	::v-deep.el-descriptions {
		padding: 0 20px;

		.el-descriptions__header {
			margin: 0;
			padding: 10px 0;
			justify-content: center;
			background-color: $--color-primary;
			color: #ffffff;

			.el-descriptions__title {
				font-weight: 500;
			}
		}

		.el-descriptions__body {
			.el-descriptions__table .el-descriptions-item__cell {
				line-height: 1.7;
			}

			.el-descriptions-item__content {
				max-width: 240px;
			}
			th.labelClassName {
				padding: 0;
			}
			th,
			td {
				padding-left: 30px;
			}
		}
	}

	::v-deep.labelClassName {
		&.el-descriptions-item__cell {
			padding: 0;
		}
	}
}

.grid-wrap {
	display: grid;
	grid-template-columns: repeat(3, 100px);
	grid-gap: 10px 10px;
}
</style>
